import List from "./views/list";
import Item from "./views/item";

import content from "./content";

const HowTo = ({ service }: { service: string }): JSX.Element => {
  const dataContent = content(service);

  return (
    <List title={dataContent.title}>
      <Item items={dataContent.list} />
    </List>
  );
};

export default HowTo;
